import React, { useState, useEffect } from "react";
import {
  TextField,
  ThemeProvider,
  createTheme,
  Autocomplete,
} from "@mui/material";
import { Fragment, useMemo, useRef } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import axios from "axios";
// import { common_axios } from "../../..";
import { common_axios } from "../../../App";
import { Form, Formik, useFormik, Field, FieldArray } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import DeleteIcon from "@mui/icons-material/Delete";
import PersonIcon from "@mui/icons-material/Person";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { withRouter } from "react-router-dom";
import RuleIcon from "@mui/icons-material/Rule";
import AttributeSelect from "./AttribiteSelect";
import OperationSelect from "./OperationSelect";
import ConditionSelect from "./ConditionSelect";
import AttributeSelect1 from "./AttributeSelect1";
import OperationSelect1 from "./OperationSelect1";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
const initialValues = {
  friends: [
    {
      attribute: "",
      values: "",
      operations: "",
      conditions: null,
    },
  ],
};
const SignupSchema = yup.object().shape({
  values: yup
    .string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("required"),
});
const SpamRules = () => {
  const Reset = () => {
    window.location.reload();
  };
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
        },
      },
    },
  });
  const [disableplus, setDisablePlus] = useState(true);
  const [spam, setSpam] = useState([]);
  const [attributeValidata, setAttributeValidate] = useState(true);
  const [hideSkeleton, setHideSkeleton] = useState();
  const handleChange = (e, index) => {
    setSpam(index.id);
  };
  const [attribute, setAttribute] = useState("");
  const [attribute1, setAttribute1] = useState();
  console.log("attribute1-----", attribute1);
  const [operations, setOperations] = useState("");
  const [conditions, setConditions] = useState("");
  const [values, setValues] = useState("");
  const [values1, setValues1] = useState("");
  const [hide, setHide] = useState(true);
  const [hideRules, setHideRules] = useState(true);
  const [operations1, setOperations1] = useState();
  const [open, setOpen] = useState();
  const [ValuesFormik, setValuesFormik] = useState();
  const [data, setData] = useState([]);
  const [response, setResponse] = useState("");
  // console.log("response21", response);
  const [value2, setValue2] = useState("");
  const [value3, setValue3] = useState("");
  const [hideCondition1, setHideCondition1] = useState(true);
  const [hideCondition, setHideCondition] = useState(true);
  const [hideCondition2, setHideCondition2] = useState(true);
  const [hideCondition3, setHideCondition3] = useState(true);
  const [hideCondition4, setHideCondition4] = useState(true);
  const [condition, setCondition] = useState("");
  const [condition1, setCondition1] = useState("");
  const [condition2, setCondition2] = useState("");
  const [condition3, setCondition3] = useState("");
  const [condition4, setCondition4] = useState("");
  const [columnState, setColumnState] = useState();
  const [conditionData, setConditionData] = useState([]);
  console.log("operations1------", condition);
  const [value01, setValue01] = useState(null);
  // console.log("condition2-----", condition2);
  const [accountcountryid, setAccountCountryId] = useState("");
  // .......................OR Condition UseState......................//
  const [actionData, setActionData] = useState([]);
  const [actionconditionData, setActionConditionData] = useState([]);
  const [andPopup1, setAndPopup1] = useState(undefined);
  const PopupModal1 = useRef(null);

  const veiwModal1 = async (cell) => {
    alert("kki")
    // await setAndPopup1(cell.row.original);
    await PopupModal1.current.click();
  };
  const [orState, setOrState] = useState({
    orAttribute1: null,
    orCondition1: null,
    orAttribute2: null,
    orCondition2: null,
    orAttribute3: null,
    orCondition3: null,
    orAttribute4: null,
    orCondition4: null,
    orAttribute5: null,
    orCondition5: null,
    orHideCondition1: true,
    orButtonCondition1: "",
    orHideCondition2: true,
    orButtonCondition2: "",
    orHideCondition3: true,
    orButtonCondition3: "",
    orHideCondition4: true,
    orButtonCondition4: "",
  });
  const [actionState, setActionState] = useState({
    actionAttribute1: null,
    actionCondition1: null,
    actionAttribute2: null,
    actionCondition2: null,
    actionAttribute3: null,
    actionCondition3: null,
    actionAttribute4: null,
    actionCondition4: null,
    actionAttribute5: null,
    actionCondition5: null,
    actionHideCondition1: true,
    actionButtonCondition1: "",
    actionHideCondition2: true,
    actionButtonCondition2: "",
    actionHideCondition3: true,
    actionButtonCondition3: "",
    actionHideCondition4: true,
    actionButtonCondition4: "",
  });
  console.log("condition288", actionState?.actionCondition1);
  console.log("condition2887", actionState?.actionCondition2);
  console.log("condition2884", actionState?.actionCondition3);
  console.log("condition2885", actionState?.actionCondition4);
  console.log("condition28856", actionState?.actionCondition5);

  // .....................................Formik............................................//
  const initialValues = {
    values: "",
    values1: "",
    values2: "",
    values3: "",
    values4: "",
    ruleName: "",
    description: "",
    // orvalues1: "",
    // orvalues2: "",
    // orvalues3: "",
    // orvalues4: "",
    // orvalues5: "",
    // actionvalues1: "",
    // actionvalues2: "",
    // actionvalues3: "",
    // actionvalues4: "",
    // actionvalues5: "",
  };
  const validationSchema = yup.object({
    values: yup
      .string()
      .min(3, "Please enter atleast 3 characters in values")
      .required("Required"),
    values1: yup
      .string()
      .min(3, "Please enter atleast 3 characters in values")
      .nullable(),
    values2: yup
      .string()
      .min(3, "Please enter atleast 3 characters in values")
      .nullable(),
    values3: yup
      .string()
      .min(3, "Please enter atleast 3 characters in values")
      .nullable(),
    values4: yup
      .string()
      .min(3, "Please enter atleast 3 characters in values")
      .nullable(),
    ruleName: yup
      .string()
      .min(3, "Please enter atleast 3 characters in RuleNmae")
      .nullable(),

    // orvalues1: yup
    // .string()
    // .min(3, "Please enter atleast 3 characters in values")
    // .required("Required"),
    // orvalues2: yup
    // .string()
    // .minorvalues2(3, "Please enter atleast 3 characters in values")
    // .nullable(),
    // orvalues3: yup
    // .string()
    // .min(3, "Please enter atleast 3 characters in values")
    // .nullable(),
    // orvalues4: yup
    // .string()
    // .min(3, "Please enter atleast 3 characters in values")
    // .nullable(),
    // orvalues5: yup
    // .string()
    // .min(3, "Please enter atleast 3 characters in values")
    // .nullable(),

    // actionvalues1: yup
    // .string()
    // .min(3, "Please enter atleast 3 characters in values")
    // .required("Required"),
    // actionvalues2: yup
    // .string()
    // .minorvalues2(3, "Please enter atleast 3 characters in values")
    // .nullable(),
    // actionvalues3: yup
    // .string()
    // .min(3, "Please enter atleast 3 characters in values")
    // .nullable(),
    // actionvalues4: yup
    // .string()
    // .min(3, "Please enter atleast 3 characters in values")
    // .nullable(),
    // actionvalues5: yup
    // .string()
    // .min(3, "Please enter atleast 3 characters in values")
    // .nullable(),
  });
  const formik = useFormik({
    initialValues: initialValues,
    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validationSchema: validationSchema,
    onSubmit: (values) => {
      SpamPost(values);
    },
  });
  const handleChange1 = (event) => {
    setCondition2(event.target.value);
  };
  const handleChange2 = (event) => {
    setCondition3(event.target.value);
  };
  const handleChange3 = (event) => {
    setCondition4(event.target.value);
  };
  const handleChange11 = (e) => {
    setResponse(e.target.value);
  };
  console.log("res-----", response);
  const callBackAttribute1 = (childData) => {
    setAttribute1(childData);
  };
  const handleChange12 = (e) => {
    setAttribute1(e.target.value);
  };
  const [attribute2, setAttribute2] = useState();
  console.log("attribute2-----", attribute2);
  const handleChange14 = (e) => {
    setAttribute2(e.target.value);
  };
  const [attribute3, setAttribute3] = useState();
  console.log("attribute3-----", attribute3);
  const handleChange16 = (e) => {
    setAttribute3(e.target.value);
  };
  const [attribute4, setAttribute4] = useState();
  console.log("attribute4", attribute4);
  const handleChange18 = (e) => {
    setAttribute4(e.target.value);
  };
  const [attribute5, setAttribute5] = useState();
  const handleChange20 = (e) => {
    setAttribute5(e.target.value);
  };
  const handleChange13 = (e) => {
    setOperations1(e.target.value);
  };
  const [operations2, setOperations2] = useState();
  const handleChange15 = (e) => {
    setOperations2(e.target.value);
  };
  const [operations3, setOperations3] = useState();
  const handleChange17 = (e) => {
    setOperations3(e.target.value);
  };
  const [operations4, setOperations4] = useState();
  const handleChange19 = (e) => {
    setOperations4(e.target.value);
  };
  const [operations5, setOperations5] = useState();
  const handleChange21 = (e) => {
    setOperations5(e.target.value);
  };
  const x = 2;
  const [variantName, setVariantName] = React.useState({
    0: false,
  });
  const handleChangeCountryAccount = (e) => {
    setAccountCountryId(e.target.value);
  };
  // ......................................Post API.......................................//
  async function SpamPost(values) {
    const body = {
      response: response,
      status:"1",
      rule: "",
      ruleName: values.ruleName,
      description: values.description,
      helperClasses: [
        {
          attribute: attribute1,
          operations: operations1,
          values: values.values,
          conditions: null,
        },
      ],
    };
    const body1 = {
      response: response,
      rule: "",
      ruleName: values.ruleName,
      description: values.description,
      helperClasses: [
        {
          attribute: attribute1,
          operations: operations1,
          values: values.values,
          conditions: condition,
        },
        {
          attribute: attribute2,
          operations: operations2,
          values: values.values1,
          conditions: null,
        },
      ],
    };
    const body2 = {
      response: response,
      rule: "",
      ruleName: values.ruleName,
      description: values.description,
      helperClasses: [
        {
          attribute: attribute1,
          operations: operations1,
          values: values.values,
          conditions: condition,
        },
        {
          attribute: attribute2,
          operations: operations2,
          values: values.values1,
          conditions: condition2,
        },
        {
          attribute: attribute3,
          operations: operations3,
          values: values.values2,
          conditions: null,
        },
      ],
    };
    const body3 = {
      response: response,
      rule: "",
      ruleName: values.ruleName,
      description: values.description,
      helperClasses: [
        {
          attribute: attribute1,
          operations: operations1,
          values: values.values,

          conditions: condition,
        },
        {
          attribute: attribute2,
          operations: operations2,
          values: values.values1,
          conditions: condition2,
        },
        {
          attribute: attribute3,
          operations: operations3,
          values: values.values2,
          conditions: condition3,
        },
        {
          attribute: attribute4,
          operations: operations4,
          values: values.values3,
          conditions: null,
        },
      ],
    };
    const body4 = {
      response: response,
      rule: "",
      ruleName: values.ruleName,
      description: values.description,
      helperClasses: [
        {
          attribute: attribute1,
          operations: operations1,
          values: values.values,
          conditions: condition,
        },
        {
          attribute: attribute2,
          operations: operations2,
          values: values.values1,
          conditions: condition2,
        },
        {
          attribute: attribute3,
          operations: operations3,
          values: values.values2,
          conditions: condition3,
        },
        {
          attribute: attribute4,
          operations: operations4,
          values: values.values3,
          conditions: condition4,
        },
        {
          attribute: attribute5,
          operations: operations5,
          values: values.values4,
          conditions: null,
        },
      ],
    };
    if (condition == "") {
      setOpen(true);
      const valll =
        await `${attribute1} ${operations1} ${formik.values.values} ${condition}`;
      body.rule = valll;
      try {
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/spam`,
          body,
          {
            headers: {
              username: localStorage.getItem("Username"),
            },
          }
        );
        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);
          setHideRules(false);
          setAttribute1(null);
          setOperations1(null);
          formik.handleReset();
          setCondition(null);
          setResponse(null);
          await setData([
            {
              attribute: attribute1,
              operations: operations1,
              values: values.values,
              conditions: "",
              response: response,
            },
          ]);
          toast.success("Rule Created Successfully!!", {
            theme: "colored",
          });
        } else if (res.data.statusDescription.statusCode == 202) {
          toast.error("Rule already exists !!", {
            theme: "colored",
          });
          setOpen(false);
        } else {
          setOpen(false);
          toast.error(res.data.statusDescription.statusdescription);
        }
      } catch (error) {
        toast.error("Please Check Your Network");
        setOpen(false);
      }
    } else if (condition != "" && hideCondition == false && condition2 == "") {
      setOpen(true);
      const valll =
        await `${attribute1} ${operations1} ${formik.values.values} ${condition} ${attribute2} ${operations2} ${formik.values.values1} ${condition2}`;
      body1.rule = valll;
      try {
        const res = await common_axios.post(
          // "http://192.168.167.66:5002/v1/drools-rule/spam",
          // body1,
          `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/spam`,
          body1,
          {
            headers: {
              username: localStorage.getItem("Username"),
            },
          }
        );
        if (res.data.statusDescription.statuscode == 200) {
          setOpen(false);
          setHideRules(false);
          setResponse(null);
          formik.handleReset();
          setAttribute1(null);
          setAttribute2(null);
          setOperations1(null);
          setOperations2(null);
          setCondition(null);
          setCondition("");
          setHideCondition(true);
          await setData([
            {
              attribute: attribute1,
              operations: operations1,
              values: values.values,
              conditions: "",
              response: response,
            },
            {
              attribute: attribute2,
              operations: operations2,
              values: values.values1,
              conditions: condition,
              response: response,
            },
          ]);
          toast.success("Rule Created Successfully!!", {
            theme: "colored",
          });
        } else if (res.data.statusDescription.statuscode == 202) {
          toast.error("Rule already exists !!", {
            theme: "colored",
          });
          setOpen(false);
        } else {
          setOpen(false);
          toast.error(res.data.statusDescription.statusdescription);
        }
      } catch (error) {
        toast.error("Please Check Your Network");
        setOpen(false);
      }
    } else if (condition != "" && condition2 != "" && condition3 == "") {
      setOpen(true);
      const valll =
        await `${attribute1} ${operations1} ${formik.values.values} ${condition} ${attribute2} ${operations2} ${formik.values.values1} ${condition2} ${attribute3} ${operations3} ${formik.values.values2} ${condition3}`;
      body2.rule = valll;
      try {
        const res = await common_axios.post(
          // "http://192.168.167.66:5002/v1/drools-rule/spam",
          // body2,
          `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/spam`,
          body2,
          {
            headers: {
              username: localStorage.getItem("Username"),
            },
          }
        );
        if (res.data.statusDescription.statuscode == 200) {
          setOpen(false);
          setHideRules(false);
          setCondition(null);
          setCondition2(null);
          setAttribute1(null);
          setAttribute2(null);
          setAttribute3(null);
          setOperations1(null);
          setOperations2(null);
          setOperations3(null);
          setHideCondition(true);
          setCondition("");
          setCondition2("");
          setHideCondition2(true);
          setResponse(null);
          formik.handleReset();
          await setData([
            {
              attribute: attribute1,
              operations: operations1,
              values: values.values,
              conditions: "",
              response: response,
            },
            {
              attribute: attribute2,
              operations: operations2,
              values: values.values1,
              conditions: condition,
              response: response,
            },
            {
              attribute: attribute3,
              operations: operations2,
              values: values.values2,
              conditions: condition2,
              response: response,
            },
          ]);
          toast.success("Rule Created Successfully!!", {
            theme: "colored",
          });
        } else if (res.data.statusDescription.statuscode == 202) {
          toast.error("Rule already exists !!", {
            theme: "colored",
          });
          setOpen(false);
        } else {
          setOpen(false);
          toast.error(res.data.statusDescription.statusdescription);
        }
      } catch (error) {
        toast.error("Please Check Your Network");
        setOpen(false);
      }
    } else if (
      condition != "" &&
      condition2 != "" &&
      condition3 != "" &&
      condition4 == "" &&
      hideCondition3 == false
    ) {
      setOpen(true);
      const valll =
        await `${attribute1} ${operations1} ${formik.values.values} ${condition} ${attribute2} ${operations2} ${formik.values.values1} ${condition2} ${attribute3} ${operations3} ${formik.values.values2} ${condition3} ${attribute4}${operations4}${formik.values.values3} ${condition4}`;
      body3.rule = valll;
      try {
        const res = await common_axios.post(
          // "http://192.168.167.66:5002/v1/drools-rule/spam",
          // body3,
          `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/spam`,
          body3,
          {
            headers: {
              username: localStorage.getItem("Username"),
            },
          }
        );
        if (res.data.statusDescription.statuscode == 200) {
          setOpen(false);
          setHideRules(false);
          formik.handleReset();
          setCondition(null);
          setResponse(null);
          setCondition(null);
          setCondition2(null);
          setCondition3(null);
          setAttribute1(null);
          setAttribute2(null);
          setAttribute3(null);
          setAttribute4(null);
          setOperations1(null);
          setOperations2(null);
          setOperations3(null);
          setOperations4(null);
          setHideCondition(true);
          setHideCondition2(true);
          setHideCondition3(true);
          setCondition("");
          setCondition2("");
          setCondition3("");
          await setData([
            {
              attribute: attribute1,
              operations: operations1,
              values: values.values,
              conditions: "",
              response: response,
            },
            {
              attribute: attribute2,
              operations: operations2,
              values: values.values1,
              conditions: condition,
              response: response,
            },
            {
              attribute: attribute3,
              operations: operations3,
              values: values.values2,
              conditions: condition2,
              response: response,
            },
            {
              attribute: attribute4,
              operations: operations4,
              values: values.values3,
              conditions: condition3,
              response: response,
            },
          ]);
          toast.success("Rule Created Successfully!!", {
            theme: "colored",
          });
        } else if (res.data.statusDescription.statuscode == 202) {
          toast.error("Rule already exists !!", {
            theme: "colored",
          });

          setOpen(false);
        } else {
          setOpen(false);
          toast.error(res.data.statusDescription.statusdescription);
        }
      } catch (error) {
        toast.error("Please Check Your Network");
        setOpen(false);
      }
    } else if (
      condition != "" &&
      condition2 != "" &&
      condition3 != "" &&
      condition4 != "" &&
      hideCondition4 == false
    ) {
      setOpen(true);
      const valll =
        await `${attribute1} ${operations1} ${formik.values.values} ${condition} ${attribute2} ${operations2} ${formik.values.values1} ${condition2} ${attribute3} ${operations3} ${formik.values.values2}  ${condition3} ${attribute4} ${operations4} ${formik.values.values3}  ${condition4} ${attribute4} ${operations4} ${formik.values.values3}  ${condition4} ${attribute5} ${operations5} ${formik.values.values4}`;
      body4.rule = valll;
      try {
        const res = await common_axios.post(
          // "http://192.168.167.66:5002/v1/drools-rule/spam",
          // body4,
          `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/spam`,
          body4,
          {
            headers: {
              username: localStorage.getItem("Username"),
            },
          }
        );
        if (res.data.statusDescription.statuscode == 200) {
          setOpen(false);
          setHideRules(false);
          formik.handleReset();
          setCondition(null);
          setCondition2(null);
          setCondition3(null);
          setCondition4(null);
          setResponse(null);
          setAttribute1(null);
          setAttribute2(null);
          setAttribute3(null);
          setAttribute4(null);
          setAttribute5(null);
          setOperations1(null);
          setOperations2(null);
          setOperations3(null);
          setOperations4(null);
          setOperations5(null);
          setCondition("");
          setCondition2("");
          setCondition3("");
          setCondition4("");
          setHideCondition(true);
          setHideCondition2(true);
          setHideCondition3(true);
          setHideCondition4(true);
          await setData([
            {
              attribute: attribute1,
              operations: operations1,
              values: values.values,
              conditions: "",
              response: response,
            },
            {
              attribute: attribute2,
              operations: operations2,
              values: values.values1,
              conditions: condition,
              response: response,
            },
            {
              attribute: attribute3,
              operations: operations3,
              values: values.values2,
              conditions: condition2,
              response: response,
            },
            {
              attribute: attribute4,
              operations: operations4,
              values: values.values3,
              conditions: condition3,
              response: response,
            },
            {
              attribute: attribute5,
              operations: operations5,
              values: values.values4,
              conditions: condition4,
              response: response,
            },
          ]);
          toast.success("Rule Created Successfully!!", {
            theme: "colored",
          });
        } else if (res.data.statusDescription.statuscode == 202) {
          toast.error("Rule already exists !!", {
            theme: "colored",
          });
          setOpen(false);
        } else {
          setOpen(false);
          toast.error(res.data.statusDescription.statusdescription);
        }
      } catch (error) {
        toast.error("Please Check Your Network");
        setOpen(false);
      }
    }
  }
  function add() {
    setHide(false);
  }
  // ...................  . . GetAPI for AND OR Condition..................................//
  async function SpamGet() {
    // console.log("first");
    try {
      setHideSkeleton(true);
      const result = await common_axios(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get-spam/attributes`
      );
      if (result.data.statusDescription.statusCode == 200) {
        setSpam(result.data.attributes);
        let temp_arr = [];

        setHideSkeleton(false);
      } else {
        setOpen(false);
        setHideSkeleton(false);
        toast.error(result.data.statusDescription.statusdescription);
      }
    } catch (error) {
      setOpen(false);
      setHideSkeleton(false);
      toast.error("Please Check Your Network");
    }
  }

  // ............................Get API For Action .........................................//
  async function ActionGet() {
    // console.log("first");
    try {
      setHideSkeleton(true);
      const result = await common_axios(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get-spam/action/attributes`
      );
      if (result.data.statusDescription.statusCode == 200) {
        setActionData(result.data.actionAttributes);
        let temp_arr = [];

        setHideSkeleton(false);
      } else {
        setActionData([]);
        setOpen(false);
        setHideSkeleton(false);
        toast.error(result.data.statusDescription.statusdescription);
      }
    } catch (error) {
      setOpen(false);
      setHideSkeleton(false);
      toast.error("Please Check Your Network");
    }
  }
  useEffect(() => {
    SpamGet();
    ActionGet();
  }, []);
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);

  const columns = useMemo(
    () => [
      {
        Header: "Attribute",
        Footer: "Attribute",
        accessor: "attribute",
      },
      {
        Header: "Operations",
        Footer: "operations",
        accessor: "operations", // accessor is the "key" in the data
      },
      {
        Header: "Values",
        Footer: "Values",
        accessor: "values",
      },
      {
        Header: "Conditions",
        Footer: "conditions",
        accessor: "conditions",
      },
      {
        Header: "Status",
        Footer: "Status",
        accessor: "response",
      },
    ],
    []
  );
  const {
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );
  const { globalFilter, pageIndex, pageSize } = state;
  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);
  const deletUser = () => {
    console.log({ selectedFlatRows });
  };
  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };
  const ResetState = () => {
    setAttribute1(null);
    setAttribute2(null);
    setAttribute3(null);
    setAttribute4(null);
    setAttribute5(null);
    setOperations1(null);
    setOperations2(null);
    setOperations3(null);
    setOperations4(null);
    setOperations5(null);
    setCondition(null);
    setCondition2(null);
    setCondition3(null);
    setCondition4(null);
    setResponse(null);
  };
  const unhideCondition = () => {
    setHideCondition(false);
    setCondition("1");
  };
  const unhideCondition2 = () => {
    setHideCondition2(false);
    setCondition2("2");
  };
  const unhideCondition3 = () => {
    setHideCondition3(false);
    setCondition3("3");
  };
  const unhideCondition4 = () => {
    setHideCondition4(false);
    setCondition4("4");
  };
  const callBackFunction = (childData) => {
    setCondition(childData);
  };
  const handleChange10 = (e) => {
    setCondition(e.target.value);
  };
  const removeConditionData = () => {
    setCondition1("");
    setHideCondition1(true);
  };
  const removeConditionData1 = () => {
    setCondition("");
    setHideCondition(true);
  };
  const removeConditionData2 = () => {
    setCondition2("");
    setHideCondition2(true);
  };
  const removeConditionData3 = () => {
    setCondition3("");
    setHideCondition3(true);
  };
  const removeConditionData4 = () => {
    setCondition4("");
    setHideCondition4(true);
  };
  // .......................Or Conditions Buttons(+,-).................................//
  const unhideConditionOr1 = () => {
    setOrState({
      ...orState,
      orHideCondition1: false,
      orButtonCondition1: "1",
    });
  };
  const unhideConditionOr2 = () => {
    setOrState({
      ...orState,
      orHideCondition2: false,
      orButtonCondition2: "2",
    });
  };
  const unhideConditionOr3 = () => {
    setOrState({
      ...orState,
      orHideCondition3: false,
      orButtonCondition3: "3",
    });
  };
  const unhideConditionOr4 = () => {
    setOrState({
      ...orState,
      orHideCondition4: false,
      orButtonCondition4: "4",
    });
  };

  const removeConditionOr1 = () => {
    setOrState({
      ...orState,
      orButtonCondition1: "",
      orHideCondition1: true,
    });
  };
  const removeConditionOr2 = () => {
    setOrState({
      ...orState,
      orButtonCondition2: "",
      orHideCondition2: true,
    });
  };
  const removeConditionOr3 = () => {
    setOrState({
      ...orState,
      orButtonCondition3: "",
      orHideCondition3: true,
    });
  };
  const removeConditionOr4 = () => {
    setOrState({
      ...orState,
      orButtonCondition4: "",
      orHideCondition4: true,
    });
  };
  // ............................End.............................................//

  // .......................Action Conditions Buttons(+,-).................................//
  const unhideConditionAction1 = () => {
    setActionState({
      ...actionState,
      actionHideCondition1: false,
      actionButtonCondition1: "1",
    });
  };
  const unhideConditionAction2 = () => {
    setActionState({
      ...actionState,
      actionHideCondition2: false,
      actionButtonCondition2: "2",
    });
  };
  const unhideConditionAction3 = () => {
    setActionState({
      ...actionState,
      actionHideCondition3: false,
      actionButtonCondition3: "3",
    });
  };
  const unhideConditionAction4 = () => {
    setActionState({
      ...actionState,
      actionHideCondition4: false,
      actionButtonCondition4: "4",
    });
  };

  const removeConditionAction1 = () => {
    setActionState({
      ...actionState,
      actionButtonCondition1: "",
      actionHideCondition1: true,
    });
  };
  const removeConditionAction2 = () => {
    setActionState({
      ...actionState,
      actionButtonCondition2: "",
      actionHideCondition2: true,
    });
  };
  const removeConditionAction3 = () => {
    setActionState({
      ...actionState,
      actionButtonCondition3: "",
      actionHideCondition3: true,
    });
  };
  const removeConditionAction4 = () => {
    setActionState({
      ...actionState,
      actionButtonCondition4: "",
      actionHideCondition4: true,
    });
  };
  //....................................end..........................................//

  useEffect(() => {
    if (attribute1 != undefined) {
      let temp_ar = [];
      for (let i = 0; i < spam?.length; i++) {
        if (attribute1?.attributeId == spam[i]?.attributeId) {
          let x = spam[i]?.rulesOperations;
          for (let j = 0; j < x.length; j++) {
            temp_ar.push(x[j]);
          }
        }
      }
      console.log("temp--", temp_ar);
      setConditionData(temp_ar);
    }
  }, [attribute1]);

  useEffect(() => {
    if (actionState?.actionAttribute1 != undefined) {
      let temp_ar = [];
      for (let i = 0; i < actionData?.length; i++) {
        if (
          actionState?.actionAttribute1?.attributeId ==
          actionData[i]?.attributeId
        ) {
          let x = actionData[i]?.actionOperations;
          for (let j = 0; j < x.length; j++) {
            temp_ar.push(x[j]);
          }
        }
      }
      console.log("temp--", temp_ar);
      // setConditionData(temp_ar);
      setActionConditionData(temp_ar);
    }
  }, [actionState.actionAttribute1]);


 


  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
        <div>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-xl-12 col-sm-12 mb-xl-0 mb-4">
              <div class="card mb-3 mt-4">
                <div class="card-header p-3 pt-2">
                  <div class="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    <i
                      class="material-icons ttl_icon  opacity-10 rule"
                      style={{ fontSize: "unset" }}
                    >
                      <RuleIcon style={{ fontSize: "28px" }} />
                    </i>
                  </div>
                  <div class="pt-1 marginleft_0">
                    <p class="text-sm mb-0 text-capitalize fw-bold">NEW RULE</p>
                    <p className="text-sm mb-0  text d-inline-block float-end">
                      To add a new condition press
                      <span className="text-danger fw-bold">+</span> this button
                    </p>
                  </div>
                </div>
                <ThemeProvider theme={theme}>
                  <div class="card-body mt-4">
                    <form
                      onSubmit={formik.handleSubmit}
                      role="form"
                      className="text-start"
                    >
                      <div className="card shadow-none border bg_blue mb-5">
                        <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                          ADD NEW RULE
                        </span>
                        <div className="card-body">
                          <h3 class="spam_create">Add Exception </h3>
                          <div className="row mt-4">
                            <div className="col-md-3">
                              <TextField
                                autoComplete="on"
                                className="w-100"
                                type="text"
                                label="RuleName"
                                name="ruleName"
                                variant="outlined"
                                size="small"
                                required
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Tooltip
                                        title="RuleName"
                                        placement="top"
                                        arrow
                                        sx={{ color: "#85CBF2" }}
                                      >
                                        <InfoIcon />
                                      </Tooltip>
                                    </InputAdornment>
                                  ),
                                }}
                                onChange={formik.handleChange}
                                value={formik.values.ruleName}
                                error={
                                  formik.touched.ruleName &&
                                  Boolean(formik.errors.ruleName)
                                }
                                helperText={
                                  formik.touched.ruleName &&
                                  formik.errors.ruleName
                                }
                              />
                            </div>
                            <div className="col-md-5 ">
                              <TextareaAutosize
                                //  disabled
                                className={
                                  formik.errors.message
                                    ? "border-color-red w-100"
                                    : "w-100  textarea_8"
                                }
                                textarea_8
                                aria-label="empty textarea"
                                placeholder="Enter Description here"
                                name="description"
                                style={{
                                  width: " 700px",
                                  minHeight: "50px",
                                  borderColor: " #48a8dd",
                                }}
                                maxlength="100"
                                // value={ruleview}
                                required
                                onChange={formik.handleChange}
                                value={formik.values.description}
                                error={
                                  formik.touched.description &&
                                  Boolean(formik.errors.description)
                                }
                                helperText={
                                  formik.touched.description &&
                                  formik.errors.description
                                }
                              />
                              <code className="d-flex align-items-center justify-content-between">
                                <p className="text" style={{ color: "#000" }}>
                                  Maximum Character length 100
                                </p>
                                <p
                                  className="text-end"
                                  style={{ color: "#000" }}
                                >
                                  Character length used:
                                  {formik.values.description.length}
                                </p>
                              </code>
                            </div>
                            <div className="col-md-2">
                              <FormControl required fullWidth size="small">
                                <InputLabel id="demo-simple-select-autowidth-label">
                                  Status
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-autowidth-label"
                                  id="demo-simple-select-autowidth"
                                  value={response}
                                  onChange={handleChange11}
                                  // autowidth
                                  label="Status"
                                >
                                  <MenuItem value={1}>Activate</MenuItem>
                                  <MenuItem value={0}>Deactivate</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-md-2">
                              <FormControl required fullWidth size="small">
                                <InputLabel id="demo-simple-select-autowidth-label">
                                  Section Type
                                </InputLabel>
                                <Select
                                  labelId="demo-simple-select-autowidth-label"
                                  id="demo-simple-select-autowidth"
                                  value={accountcountryid}
                                  onChange={handleChangeCountryAccount}
                                  // autowidth
                                  label="Section Type"
                                >
                                  <MenuItem value={0}>Country Id</MenuItem>
                                  <MenuItem value={1}>Account Id</MenuItem>
                                </Select>
                              </FormControl>
                            </div>
                            {accountcountryid == 0 ? (
                              <>
                                <div className="col-md-2">
                                  <Autocomplete
                                    disablePortal
                                    aria-required
                                    className="w-100"
                                    id="combo-box-demo"
                                    size="small"
                                    options={spam}
                                    getOptionLabel={(option) =>
                                      option.attribute
                                    }
                                    value={attribute1}
                                    // onChange={handleChange12}
                                    onChange={(e, value) => {
                                      console.log("value--", value);
                                      // setColumnState(value);
                                      setAttribute1(value);
                                    }}
                                    sx={{ width: 300 }}
                                    renderInput={(params) => (
                                      <TextField
                                        required
                                        {...params}
                                        label="Select Country "
                                      />
                                    )}
                                  />
                                </div>
                              </>
                            ) : (
                              <>
                                <div className="col-md-2">
                                  <Autocomplete
                                    disablePortal
                                    aria-required
                                    className="w-100"
                                    id="combo-box-demo"
                                    size="small"
                                    options={spam}
                                    getOptionLabel={(option) =>
                                      option.attribute
                                    }
                                    value={attribute1}
                                    // onChange={handleChange12}
                                    onChange={(e, value) => {
                                      console.log("value--", value);
                                      // setColumnState(value);
                                      setAttribute1(value);
                                    }}
                                    sx={{ width: 300 }}
                                    renderInput={(params) => (
                                      <TextField
                                        required
                                        {...params}
                                        label="Account Id "
                                      />
                                    )}
                                  />
                                </div>
                              </>
                            )}
                          </div>
                          <div className="card-body px-0 text-lg-start text-center">
                            {/* ..............................AND Condition...................................... */}

                            <h3 class="spam_create">
                              Conditions{" "}
                              <span class="">(Match all of the below)</span>
                            </h3>
                            <div className="mt-3">
                              <div className="row mt-2">
                                <div className="col-md-2">
                                  {hideSkeleton == true ? (
                                    <>
                                      {" "}
                                      <Box sx={{ width: 150 }}>
                                        <Skeleton />
                                        <Skeleton animation="wave" />
                                        {/* <Skeleton animation={false} /> */}
                                      </Box>
                                    </>
                                  ) : (
                                    <>
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={spam}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={attribute1}
                                        // onChange={handleChange12}
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          // setColumnState(value);
                                          setAttribute1(value);
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Column Name"
                                          />
                                        )}
                                      />
                                    </>
                                  )}
                                </div>
                                <div className="col-md-2">
                                  {hideSkeleton == true ? (
                                    <>
                                      {" "}
                                      <Box sx={{ width: 150 }}>
                                        <Skeleton />
                                        <Skeleton animation="wave" />
                                        {/* <Skeleton animation={false} /> */}
                                      </Box>
                                    </>
                                  ) : (
                                    <>
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                    Select Condition
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations1}
                                      onChange={handleChange13}
                                      autowidth
                                      label="Select Condition"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={conditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={operations1}
                                        // onChange={(e, value) => handlechange(value)}
                                        onChange={(e, value) => {
                                          setOperations1(value?.operations);
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </>
                                  )}
                                </div>
                                <div className="col-md-2">
                                  {/* <div className="d-flex justify-content-between align-items-center"> */}
                                  <TextField
                                    autoComplete="on"
                                    className="m-0 w-100"
                                    type="text"
                                    label="Value"
                                    name="values"
                                    variant="outlined"
                                    size="small"
                                    required
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Tooltip
                                            title="Value"
                                            placement="top"
                                            arrow
                                            sx={{ color: "#85CBF2" }}
                                          >
                                            <InfoIcon />
                                          </Tooltip>
                                        </InputAdornment>
                                      ),
                                    }}
                                    onChange={formik.handleChange}
                                    value={formik.values.values}
                                    error={
                                      formik.touched.values &&
                                      Boolean(formik.errors.values)
                                    }
                                    helperText={
                                      formik.touched.values &&
                                      formik.errors.values
                                    }
                                  />
                                  {/* <span className="d-block">fgffgfgg</span> */}
                                  {/* </div> */}
                                </div>
                                <div className="col-md-3">
                                  <span className="d-block pop_up"
                                  >
                                    {attribute1?.attribute}
                                  
                <a
              
                 onClick={veiwModal1}
                >
                  <PersonIcon/>
                  
                </a>
                                    
                                  </span>
                                </div>
                                {/* {hideCondition ? (
                              <></>
                            ) : (
                              <>
                                <div className="col-md-2">
                                  {hideSkeleton == true ? (
                                    <>
                                      <Box sx={{ width: 150 }}>
                                        <Skeleton />
                                        <Skeleton animation="wave" />
                                        <Skeleton animation={false} />
                                      </Box>
                                    </>
                                  ) : (
                                    <>
                                      <div className="w-100">
                                        <FormControl
                                          required
                                          fullWidth
                                          size="small"
                                        >
                                          <InputLabel id="demo-simple-select-autowidth-label">
                                            Conditions
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            value={condition}
                                            onChange={handleChange10}
                                            autowidth
                                            label="Conditions"
                                          >
                                            {["AND", "OR"].map((data) => {
                                              return (
                                                <MenuItem value={data}>
                                                  {data}
                                                </MenuItem>
                                              );
                                            })}
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </>
                            )} */}
                                <div className="col-md-3 mt-auto">
                                  <button
                                    type="button"
                                    className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                    onClick={unhideCondition}
                                  >
                                    +
                                  </button>
                                  {/* <button
                                    type="button"
                                    className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                    onClick={removeConditionData}
                                  >
                                    -
                                  </button> */}
                                </div>
                              </div>

                              <div className="row mt-2">
                                {condition ? (
                                  <>
                                    <div className="col-md-2">
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={spam}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={attribute2}
                                        // onChange={handleChange12}
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          // setColumnState(value);
                                          setAttribute2(value);
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Column Name"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Operation
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations2}
                                      onChange={handleChange15}
                                      autowidth
                                      label="Operations"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={conditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={operations2}
                                        // onChange={(e, value) => handlechange(value)}
                                        onChange={(e, value) => {
                                          setOperations2(value?.operations);
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <TextField
                                        required={condition}
                                        autoComplete="on"
                                        className="m-0 w-100"
                                        type="text"
                                        label="Value"
                                        name="values1"
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip
                                                title="Value"
                                                placement="top"
                                                arrow
                                                sx={{ color: "#85CBF2" }}
                                              >
                                                <InfoIcon />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        onChange={formik.handleChange}
                                        value={formik.values.values1}
                                        error={
                                          formik.touched.values1 &&
                                          Boolean(formik.errors.values1)
                                        }
                                        helperText={
                                          formik.touched.values1 &&
                                          formik.errors.values1
                                        }
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <span className="d-block pop_up">
                                        {attribute2?.attribute}
                                        <PersonIcon />
                                      </span>
                                    </div>

                                    <div className="col-md-3 ">
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                        onClick={unhideCondition2}
                                      >
                                        +
                                      </button>
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                        onClick={removeConditionData1}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="row mt-2">
                                {condition2 ? (
                                  <>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Attribute
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={attribute3}
                                      onChange={handleChange16}
                                      autowidth
                                      label="Attribute"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.types}>
                                            {arg.types}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={spam}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={attribute3}
                                        // onChange={handleChange12}
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          // setColumnState(value);
                                          setAttribute3(value);
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Column Name"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Operation
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations3}
                                      onChange={handleChange17}
                                      autowidth
                                      label="Operations"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={conditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={operations3}
                                        // onChange={(e, value) => handlechange(value)}
                                        onChange={(e, value) => {
                                          setOperations3(value?.operations);
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <TextField
                                        autoComplete="on"
                                        className="m-0 w-100"
                                        type="text"
                                        label="Value"
                                        name="values2"
                                        variant="outlined"
                                        size="small"
                                        required={condition2}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip
                                                title="Value"
                                                placement="top"
                                                arrow
                                                sx={{ color: "#85CBF2" }}
                                              >
                                                <InfoIcon />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        onChange={formik.handleChange}
                                        value={formik.values.values2}
                                        error={
                                          formik.touched.values2 &&
                                          Boolean(formik.errors.values2)
                                        }
                                        helperText={
                                          formik.touched.values2 &&
                                          formik.errors.values2
                                        }
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <span className="d-block pop_up">
                                        {attribute3?.attribute}
                                        <PersonIcon />
                                      </span>
                                    </div>
                                    {/* {hideCondition3 == false && (
                                  <>
                                    <div className="col-md-2">
                                      <div className="w-100">
                                        <FormControl
                                          required
                                          fullWidth
                                          size="small"
                                        >
                                          <InputLabel id="demo-simple-select-autowidth-label">
                                            Conditions
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            value={condition3}
                                            onChange={handleChange2}
                                            autowidth
                                            label="Conditions"
                                          >
                                            {["AND", "OR"].map((data) => {
                                              return (
                                                <MenuItem value={data}>
                                                  {data}
                                                </MenuItem>
                                              );
                                            })}
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </div>
                                  </>
                                )} */}
                                    <div className="col-md-3 mt-auto">
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                        onClick={unhideCondition3}
                                      >
                                        +
                                      </button>
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                        onClick={removeConditionData2}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="row mt-2">
                                {condition3 ? (
                                  <>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Attribute
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={attribute4}
                                      onChange={handleChange18}
                                      autowidth
                                      label="Attribute"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.types}>
                                            {arg.types}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={spam}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={attribute4}
                                        // onChange={handleChange12}
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          // setColumnState(value);
                                          setAttribute4(value);
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Column Name"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Operation
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations4}
                                      onChange={handleChange19}
                                      autowidth
                                      label="Operations"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={conditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={operations4}
                                        // onChange={(e, value) => handlechange(value)}
                                        onChange={(e, value) => {
                                          setOperations4(value?.operations);
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <TextField
                                        autoComplete="on"
                                        className="m-0 w-100"
                                        type="text"
                                        label="Value"
                                        name="values3"
                                        variant="outlined"
                                        size="small"
                                        required={condition2}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip
                                                title="Value"
                                                placement="top"
                                                arrow
                                                sx={{ color: "#85CBF2" }}
                                              >
                                                <InfoIcon />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        onChange={formik.handleChange}
                                        value={formik.values.values3}
                                        error={
                                          formik.touched.values3 &&
                                          Boolean(formik.errors.values3)
                                        }
                                        helperText={
                                          formik.touched.values3 &&
                                          formik.errors.values3
                                        }
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <span className="d-block pop_up">
                                        {attribute4?.attribute}
                                        <PersonIcon />
                                      </span>
                                    </div>
                                    <div className="col-md-3 mt-auto">
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                        onClick={unhideCondition4}
                                      >
                                        +
                                      </button>
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                        onClick={removeConditionData3}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="row mt-2">
                                {condition4 ? (
                                  <>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Attribute
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={attribute5}
                                      onChange={handleChange20}
                                      autowidth
                                      label="Attribute"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.types}>
                                            {arg.types}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={spam}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={attribute5}
                                        // onChange={handleChange12}
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          // setColumnState(value);
                                          setAttribute5(value);
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Column Name"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Operation
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations5}
                                      onChange={handleChange21}
                                      autowidth
                                      label="Operations"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={conditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={operations5}
                                        // onChange={(e, value) => handlechange(value)}
                                        onChange={(e, value) => {
                                          setOperations5(value?.operations);
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <TextField
                                        autoComplete="on"
                                        className="m-0 w-100"
                                        type="text"
                                        label="Value"
                                        name="values4"
                                        variant="outlined"
                                        size="small"
                                        required={condition2}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip
                                                title="Value"
                                                placement="top"
                                                arrow
                                                sx={{ color: "#85CBF2" }}
                                              >
                                                <InfoIcon />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        onChange={formik.handleChange}
                                        value={formik.values.values4}
                                        error={
                                          formik.touched.values4 &&
                                          Boolean(formik.errors.values4)
                                        }
                                        helperText={
                                          formik.touched.values4 &&
                                          formik.errors.values4
                                        }
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <span className="d-block pop_up">
                                        {attribute5?.attribute}
                                        <PersonIcon />
                                      </span>
                                    </div>
                                    <div className="col-md-3 mt-auto">
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                        onClick={removeConditionData4}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                            {/* ..................................END OF AND Condition............................. */}

                            {/* ......................................OR Condition 2................................. */}

                            <h3 class="spam_create">
                              Conditions
                              <span class="">(Match any of the below)</span>
                            </h3>
                            <div className="mt-3">
                              <div className="row mt-2">
                                <div className="col-md-2">
                                  {hideSkeleton == true ? (
                                    <>
                                      {" "}
                                      <Box sx={{ width: 150 }}>
                                        <Skeleton />
                                        <Skeleton animation="wave" />
                                        {/* <Skeleton animation={false} /> */}
                                      </Box>
                                    </>
                                  ) : (
                                    <>
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={spam}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        // value={attribute1}?
                                        value={orState?.orAttribute1?.attribute}
                                        // onChange={handleChange12}
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          // setColumnState(value);
                                          // setAttribute1(value);
                                          setOrState({
                                            ...orState,
                                            orAttribute1: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Column Name"
                                          />
                                        )}
                                      />
                                    </>
                                  )}
                                </div>
                                <div className="col-md-2">
                                  {hideSkeleton == true ? (
                                    <>
                                      {" "}
                                      <Box sx={{ width: 150 }}>
                                        <Skeleton />
                                        <Skeleton animation="wave" />
                                        {/* <Skeleton animation={false} /> */}
                                      </Box>
                                    </>
                                  ) : (
                                    <>
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={conditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={
                                          orState?.orCondition1?.operations
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setOrState({
                                            ...orState,
                                            orCondition1: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </>
                                  )}
                                </div>
                                <div className="col-md-2">
                                  {/* <div className="d-flex justify-content-between align-items-center"> */}
                                  <TextField
                                    autoComplete="on"
                                    className="m-0 w-100"
                                    type="text"
                                    label="Value"
                                    name="values"
                                    variant="outlined"
                                    size="small"
                                    required
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Tooltip
                                            title="Value"
                                            placement="top"
                                            arrow
                                            sx={{ color: "#85CBF2" }}
                                          >
                                            <InfoIcon />
                                          </Tooltip>
                                        </InputAdornment>
                                      ),
                                    }}
                                    onChange={formik.handleChange}
                                    value={formik.values.values}
                                    error={
                                      formik.touched.values &&
                                      Boolean(formik.errors.values)
                                    }
                                    helperText={
                                      formik.touched.values &&
                                      formik.errors.values
                                    }
                                  />
                                  {/* <span className="d-block">fgffgfgg</span> */}
                                  {/* </div> */}
                                </div>
                                <div className="col-md-3">
                                  <span className="d-block pop_up">
                                    {orState?.orAttribute1?.attribute}

                                    <PersonIcon />
                                  </span>
                                </div>
                                {/* {hideCondition ? (
                              <></>
                            ) : (
                              <>
                                <div className="col-md-2">
                                  {hideSkeleton == true ? (
                                    <>
                                      <Box sx={{ width: 150 }}>
                                        <Skeleton />
                                        <Skeleton animation="wave" />
                                        <Skeleton animation={false} />
                                      </Box>
                                    </>
                                  ) : (
                                    <>
                                      <div className="w-100">
                                        <FormControl
                                          required
                                          fullWidth
                                          size="small"
                                        >
                                          <InputLabel id="demo-simple-select-autowidth-label">
                                            Conditions
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            value={condition}
                                            onChange={handleChange10}
                                            autowidth
                                            label="Conditions"
                                          >
                                            {["AND", "OR"].map((data) => {
                                              return (
                                                <MenuItem value={data}>
                                                  {data}
                                                </MenuItem>
                                              );
                                            })}
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </>
                            )} */}
                                <div className="col-md-3 mt-auto">
                                  <button
                                    type="button"
                                    className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                    onClick={unhideConditionOr1}
                                    // onClick={unhideCondition}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                              <div className="row mt-2">
                                {orState?.orButtonCondition1 ? (
                                  <>
                                    <div className="col-md-2">
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={spam}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={orState?.orAttribute2?.attribute}
                                        // onChange={handleChange12}
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          // setColumnState(value);
                                          // setAttribute1(value);
                                          setOrState({
                                            ...orState,
                                            orAttribute2: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Column Name"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={conditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={
                                          orState?.orCondition2?.operations
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setOrState({
                                            ...orState,
                                            orCondition2: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <TextField
                                        required={condition}
                                        autoComplete="on"
                                        className="m-0 w-100"
                                        type="text"
                                        label="Value"
                                        name="values1"
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip
                                                title="Value"
                                                placement="top"
                                                arrow
                                                sx={{ color: "#85CBF2" }}
                                              >
                                                <InfoIcon />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        onChange={formik.handleChange}
                                        value={formik.values.values1}
                                        error={
                                          formik.touched.values1 &&
                                          Boolean(formik.errors.values1)
                                        }
                                        helperText={
                                          formik.touched.values1 &&
                                          formik.errors.values1
                                        }
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <span className="d-block pop_up">
                                        {orState?.orAttribute2?.attribute}{" "}
                                        <PersonIcon />
                                      </span>
                                    </div>

                                    <div className="col-md-3 ">
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                        onClick={unhideConditionOr2}
                                      >
                                        +
                                      </button>
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                        onClick={removeConditionOr1}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="row mt-2">
                                {orState?.orButtonCondition2 ? (
                                  <>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Attribute
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={attribute3}
                                      onChange={handleChange16}
                                      autowidth
                                      label="Attribute"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.types}>
                                            {arg.types}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={spam}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={orState?.orAttribute3?.attribute}
                                        // onChange={handleChange12}
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          // setColumnState(value);
                                          // setAttribute1(value);
                                          setOrState({
                                            ...orState,
                                            orAttribute3: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Column Name"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Operation
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations3}
                                      onChange={handleChange17}
                                      autowidth
                                      label="Operations"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={conditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={
                                          orState?.orCondition3?.operations
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setOrState({
                                            ...orState,
                                            orCondition3: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <TextField
                                        autoComplete="on"
                                        className="m-0 w-100"
                                        type="text"
                                        label="Value"
                                        name="values2"
                                        variant="outlined"
                                        size="small"
                                        required={condition2}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip
                                                title="Value"
                                                placement="top"
                                                arrow
                                                sx={{ color: "#85CBF2" }}
                                              >
                                                <InfoIcon />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        onChange={formik.handleChange}
                                        value={formik.values.values2}
                                        error={
                                          formik.touched.values2 &&
                                          Boolean(formik.errors.values2)
                                        }
                                        helperText={
                                          formik.touched.values2 &&
                                          formik.errors.values2
                                        }
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <span className="d-block pop_up">
                                        {orState?.orAttribute3?.attribute}
                                        <PersonIcon />
                                      </span>
                                    </div>
                                    {/* {hideCondition3 == false && (
                                  <>
                                    <div className="col-md-2">
                                      <div className="w-100">
                                        <FormControl
                                          required
                                          fullWidth
                                          size="small"
                                        >
                                          <InputLabel id="demo-simple-select-autowidth-label">
                                            Conditions
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            value={condition3}
                                            onChange={handleChange2}
                                            autowidth
                                            label="Conditions"
                                          >
                                            {["AND", "OR"].map((data) => {
                                              return (
                                                <MenuItem value={data}>
                                                  {data}
                                                </MenuItem>
                                              );
                                            })}
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </div>
                                  </>
                                )} */}
                                    <div className="col-md-3 mt-auto">
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                        onClick={unhideConditionOr3}
                                      >
                                        +
                                      </button>
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                        onClick={removeConditionOr2}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="row mt-2">
                                {orState?.orButtonCondition3 ? (
                                  <>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Attribute
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={attribute4}
                                      onChange={handleChange18}
                                      autowidth
                                      label="Attribute"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.types}>
                                            {arg.types}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={spam}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={orState?.orAttribute4?.attribute}
                                        // onChange={handleChange12}
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          // setColumnState(value);
                                          // setAttribute1(value);
                                          setOrState({
                                            ...orState,
                                            orAttribute4: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Column Name"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Operation
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations4}
                                      onChange={handleChange19}
                                      autowidth
                                      label="Operations"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={conditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={
                                          orState?.orCondition4?.operations
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setOrState({
                                            ...orState,
                                            orCondition4: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <TextField
                                        autoComplete="on"
                                        className="m-0 w-100"
                                        type="text"
                                        label="Value"
                                        name="values3"
                                        variant="outlined"
                                        size="small"
                                        required={condition2}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip
                                                title="Value"
                                                placement="top"
                                                arrow
                                                sx={{ color: "#85CBF2" }}
                                              >
                                                <InfoIcon />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        onChange={formik.handleChange}
                                        value={formik.values.values3}
                                        error={
                                          formik.touched.values3 &&
                                          Boolean(formik.errors.values3)
                                        }
                                        helperText={
                                          formik.touched.values3 &&
                                          formik.errors.values3
                                        }
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <span className="d-block pop_up">
                                        {orState?.orAttribute4?.attribute}
                                        <PersonIcon />
                                      </span>
                                    </div>
                                    <div className="col-md-3 mt-auto">
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                        onClick={unhideConditionOr4}
                                      >
                                        +
                                      </button>
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                        onClick={removeConditionOr3}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="row mt-2">
                                {orState?.orButtonCondition4 ? (
                                  <>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Attribute
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={attribute5}
                                      onChange={handleChange20}
                                      autowidth
                                      label="Attribute"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.types}>
                                            {arg.types}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={spam}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={orState?.orAttribute5?.attribute}
                                        // onChange={handleChange12}
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          // setColumnState(value);
                                          // setAttribute1(value);
                                          setOrState({
                                            ...orState,
                                            orAttribute5: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Column Name"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Operation
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations5}
                                      onChange={handleChange21}
                                      autowidth
                                      label="Operations"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={conditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={
                                          orState?.orCondition5?.operations
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setOrState({
                                            ...orState,
                                            orCondition5: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <TextField
                                        autoComplete="on"
                                        className="m-0 w-100"
                                        type="text"
                                        label="Value"
                                        name="values4"
                                        variant="outlined"
                                        size="small"
                                        required={condition2}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip
                                                title="Value"
                                                placement="top"
                                                arrow
                                                sx={{ color: "#85CBF2" }}
                                              >
                                                <InfoIcon />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        onChange={formik.handleChange}
                                        value={formik.values.values4}
                                        error={
                                          formik.touched.values4 &&
                                          Boolean(formik.errors.values4)
                                        }
                                        helperText={
                                          formik.touched.values4 &&
                                          formik.errors.values4
                                        }
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <span className="d-block pop_up">
                                        {orState?.orAttribute5?.attribute}
                                        <PersonIcon />
                                      </span>
                                    </div>
                                    <div className="col-md-3 mt-auto">
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                        onClick={removeConditionOr4}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>

                            {/*.....................................End Of Condition................................... */}
                            {/* </div> */}

                            {/* ...............................Action Condition 3.............................. */}

                            <h3 class="spam_create">Action</h3>
                            <div className="mt-3">
                              <div className="row mt-2">
                                <div className="col-md-2">
                                  {hideSkeleton == true ? (
                                    <>
                                      {" "}
                                      <Box sx={{ width: 150 }}>
                                        <Skeleton />
                                        <Skeleton animation="wave" />
                                        {/* <Skeleton animation={false} /> */}
                                      </Box>
                                    </>
                                  ) : (
                                    <>
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={actionData}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={
                                          actionState?.actionAttribute1
                                            ?.attribute
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setActionState({
                                            ...actionState,
                                            actionAttribute1: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Action Name"
                                          />
                                        )}
                                      />
                                    </>
                                  )}
                                </div>
                                <div className="col-md-2">
                                  {hideSkeleton == true ? (
                                    <>
                                      {" "}
                                      <Box sx={{ width: 150 }}>
                                        <Skeleton />
                                        <Skeleton animation="wave" />
                                        {/* <Skeleton animation={false} /> */}
                                      </Box>
                                    </>
                                  ) : (
                                    <>
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                    Select Condition
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations1}
                                      onChange={handleChange13}
                                      autowidth
                                      label="Select Condition"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={actionconditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={
                                          actionState?.actionCondition1
                                            ?.operations
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setActionState({
                                            ...actionState,
                                            actionCondition1: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </>
                                  )}
                                </div>
                                <div className="col-md-2">
                                  {/* <div className="d-flex justify-content-between align-items-center"> */}
                                  <TextField
                                    autoComplete="on"
                                    className="m-0 w-100"
                                    type="text"
                                    label="Value"
                                    name="values"
                                    variant="outlined"
                                    size="small"
                                    required
                                    InputProps={{
                                      endAdornment: (
                                        <InputAdornment position="end">
                                          <Tooltip
                                            title="Value"
                                            placement="top"
                                            arrow
                                            sx={{ color: "#85CBF2" }}
                                          >
                                            <InfoIcon />
                                          </Tooltip>
                                        </InputAdornment>
                                      ),
                                    }}
                                    onChange={formik.handleChange}
                                    value={formik.values.values}
                                    error={
                                      formik.touched.values &&
                                      Boolean(formik.errors.values)
                                    }
                                    helperText={
                                      formik.touched.values &&
                                      formik.errors.values
                                    }
                                  />
                                  {/* <span className="d-block">fgffgfgg</span> */}
                                  {/* </div> */}
                                </div>
                                <div className="col-md-3">
                                  <span className="d-block pop_up">
                                    {actionState?.actionAttribute1?.attribute}
                                    <PersonIcon />
                                  </span>
                                </div>
                                {/* {hideCondition ? (
                              <></>
                            ) : (
                              <>
                                <div className="col-md-2">
                                  {hideSkeleton == true ? (
                                    <>
                                      <Box sx={{ width: 150 }}>
                                        <Skeleton />
                                        <Skeleton animation="wave" />
                                        <Skeleton animation={false} />
                                      </Box>
                                    </>
                                  ) : (
                                    <>
                                      <div className="w-100">
                                        <FormControl
                                          required
                                          fullWidth
                                          size="small"
                                        >
                                          <InputLabel id="demo-simple-select-autowidth-label">
                                            Conditions
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            value={condition}
                                            onChange={handleChange10}
                                            autowidth
                                            label="Conditions"
                                          >
                                            {["AND", "OR"].map((data) => {
                                              return (
                                                <MenuItem value={data}>
                                                  {data}
                                                </MenuItem>
                                              );
                                            })}
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </>
                            )} */}
                                <div className="col-md-3 mt-auto">
                                  <button
                                    type="button"
                                    className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                    onClick={unhideConditionAction1}
                                  >
                                    +
                                  </button>
                                </div>
                              </div>
                              <div className="row mt-2">
                                {actionState?.actionButtonCondition1 ? (
                                  <>
                                    <div className="col-md-2">
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={actionData}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={
                                          actionState?.actionAttribute2
                                            ?.attribute
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setActionState({
                                            ...actionState,
                                            actionAttribute2: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Action Name"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Operation
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations2}
                                      onChange={handleChange15}
                                      autowidth
                                      label="Operations"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={actionconditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={
                                          actionState?.actionCondition2
                                            ?.operations
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setActionState({
                                            ...actionState,
                                            actionCondition2: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <TextField
                                        required={condition}
                                        autoComplete="on"
                                        className="m-0 w-100"
                                        type="text"
                                        label="Value"
                                        name="values1"
                                        variant="outlined"
                                        size="small"
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip
                                                title="Value"
                                                placement="top"
                                                arrow
                                                sx={{ color: "#85CBF2" }}
                                              >
                                                <InfoIcon />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        onChange={formik.handleChange}
                                        value={formik.values.values1}
                                        error={
                                          formik.touched.values1 &&
                                          Boolean(formik.errors.values1)
                                        }
                                        helperText={
                                          formik.touched.values1 &&
                                          formik.errors.values1
                                        }
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <span className="d-block pop_up">
                                        {
                                          actionState?.actionAttribute2
                                            ?.attribute
                                        }

                                        <PersonIcon />
                                      </span>
                                    </div>
                                    {/* {hideCondition2 == false && (
                                  <>
                                    <div className="col-md-2">
                                      <div className="w-100">
                                        <FormControl
                                          required
                                          fullWidth
                                          size="small"
                                        >
                                          <InputLabel id="demo-simple-select-autowidth-label">
                                            Conditions
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            value={condition2}
                                            onChange={handleChange1}
                                            autowidth
                                            label="Conditions"
                                          >
                                          
                                            {["AND", "OR"].map((data) => {
                                              return (
                                                <MenuItem value={data}>
                                                  {data}
                                                </MenuItem>
                                              );
                                            })}
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </div>
                                  </>
                                )} */}
                                    <div className="col-md-3 ">
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                        onClick={unhideConditionAction2}
                                      >
                                        +
                                      </button>
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                        onClick={removeConditionAction1}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="row mt-2">
                                {actionState?.actionButtonCondition2 ? (
                                  <>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Attribute
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={attribute3}
                                      onChange={handleChange16}
                                      autowidth
                                      label="Attribute"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.types}>
                                            {arg.types}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={actionData}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={
                                          actionState?.actionAttribute3
                                            ?.attribute
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setActionState({
                                            ...actionState,
                                            actionAttribute3: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Action Name"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Operation
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations3}
                                      onChange={handleChange17}
                                      autowidth
                                      label="Operations"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={actionconditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={
                                          actionState?.actionCondition3
                                            ?.operations
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setActionState({
                                            ...actionState,
                                            actionCondition3: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <TextField
                                        autoComplete="on"
                                        className="m-0 w-100"
                                        type="text"
                                        label="Value"
                                        name="values2"
                                        variant="outlined"
                                        size="small"
                                        required={condition2}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip
                                                title="Value"
                                                placement="top"
                                                arrow
                                                sx={{ color: "#85CBF2" }}
                                              >
                                                <InfoIcon />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        onChange={formik.handleChange}
                                        value={formik.values.values2}
                                        error={
                                          formik.touched.values2 &&
                                          Boolean(formik.errors.values2)
                                        }
                                        helperText={
                                          formik.touched.values2 &&
                                          formik.errors.values2
                                        }
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <span className="d-block pop_up">
                                        {
                                          actionState?.actionAttribute3
                                            ?.attribute
                                        }
                                        <PersonIcon />
                                      </span>
                                    </div>
                                    {/* {hideCondition3 == false && (
                                  <>
                                    <div className="col-md-2">
                                      <div className="w-100">
                                        <FormControl
                                          required
                                          fullWidth
                                          size="small"
                                        >
                                          <InputLabel id="demo-simple-select-autowidth-label">
                                            Conditions
                                          </InputLabel>
                                          <Select
                                            labelId="demo-simple-select-autowidth-label"
                                            id="demo-simple-select-autowidth"
                                            value={condition3}
                                            onChange={handleChange2}
                                            autowidth
                                            label="Conditions"
                                          >
                                            {["AND", "OR"].map((data) => {
                                              return (
                                                <MenuItem value={data}>
                                                  {data}
                                                </MenuItem>
                                              );
                                            })}
                                          </Select>
                                        </FormControl>
                                      </div>
                                    </div>
                                  </>
                                )} */}
                                    <div className="col-md-3 mt-auto">
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                        onClick={unhideConditionAction3}
                                      >
                                        +
                                      </button>
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                        onClick={removeConditionAction2}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="row mt-2">
                                {actionState?.actionButtonCondition3 ? (
                                  <>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Attribute
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={attribute4}
                                      onChange={handleChange18}
                                      autowidth
                                      label="Attribute"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.types}>
                                            {arg.types}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={actionData}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={
                                          actionState?.actionAttribute4
                                            ?.attribute
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setActionState({
                                            ...actionState,
                                            actionAttribute4: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Action Name"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Operation
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations4}
                                      onChange={handleChange19}
                                      autowidth
                                      label="Operations"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}
                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={actionconditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={
                                          actionState?.actionCondition4
                                            ?.operations
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setActionState({
                                            ...actionState,
                                            actionCondition4: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <TextField
                                        autoComplete="on"
                                        className="m-0 w-100"
                                        type="text"
                                        label="Value"
                                        name="values3"
                                        variant="outlined"
                                        size="small"
                                        required={condition2}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip
                                                title="Value"
                                                placement="top"
                                                arrow
                                                sx={{ color: "#85CBF2" }}
                                              >
                                                <InfoIcon />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        onChange={formik.handleChange}
                                        value={formik.values.values3}
                                        error={
                                          formik.touched.values3 &&
                                          Boolean(formik.errors.values3)
                                        }
                                        helperText={
                                          formik.touched.values3 &&
                                          formik.errors.values3
                                        }
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <span className="d-block pop_up">
                                        {
                                          actionState?.actionAttribute4
                                            ?.attribute
                                        }
                                        <PersonIcon />
                                      </span>
                                    </div>
                                    <div className="col-md-3 mt-auto">
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 me-3  bgcolor"
                                        onClick={unhideConditionAction4}
                                      >
                                        +
                                      </button>
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                        onClick={removeConditionAction3}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                              <div className="row mt-2">
                                {actionState?.actionButtonCondition4 ? (
                                  <>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Attribute
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={attribute5}
                                      onChange={handleChange20}
                                      autowidth
                                      label="Attribute"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.types}>
                                            {arg.types}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={actionData}
                                        getOptionLabel={(option) =>
                                          option.attribute
                                        }
                                        value={
                                          actionState?.actionAttribute5
                                            ?.attribute
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setActionState({
                                            ...actionState,
                                            actionAttribute5: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Actiion Name"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      {/* <FormControl required fullWidth size="small">
                                    <InputLabel id="demo-simple-select-autowidth-label">
                                      Operation
                                    </InputLabel>
                                    <Select
                                      labelId="demo-simple-select-autowidth-label"
                                      id="demo-simple-select-autowidth"
                                      value={operations5}
                                      onChange={handleChange21}
                                      autowidth
                                      label="Operations"
                                      required
                                    >
                                      {spam?.map((arg) => {
                                        return (
                                          <MenuItem value={arg.operations}>
                                            {arg.operations}
                                          </MenuItem>
                                        );
                                      })}
                                    </Select>
                                  </FormControl> */}

                                      <Autocomplete
                                        disablePortal
                                        aria-required
                                        className="w-100"
                                        id="combo-box-demo"
                                        size="small"
                                        options={actionconditionData}
                                        getOptionLabel={(option) =>
                                          option.operations
                                        }
                                        value={
                                          actionState?.actionCondition5
                                            ?.operations
                                        }
                                        onChange={(e, value) => {
                                          console.log("value--", value);
                                          setActionState({
                                            ...actionState,
                                            actionCondition5: value,
                                          });
                                        }}
                                        sx={{ width: 300 }}
                                        renderInput={(params) => (
                                          <TextField
                                            required
                                            {...params}
                                            label="Select Condition"
                                          />
                                        )}
                                      />
                                    </div>
                                    <div className="col-md-2">
                                      <TextField
                                        autoComplete="on"
                                        className="m-0 w-100"
                                        type="text"
                                        label="Value"
                                        name="values4"
                                        variant="outlined"
                                        size="small"
                                        required={condition2}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip
                                                title="Value"
                                                placement="top"
                                                arrow
                                                sx={{ color: "#85CBF2" }}
                                              >
                                                <InfoIcon />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                        onChange={formik.handleChange}
                                        value={formik.values.values4}
                                        error={
                                          formik.touched.values4 &&
                                          Boolean(formik.errors.values4)
                                        }
                                        helperText={
                                          formik.touched.values4 &&
                                          formik.errors.values4
                                        }
                                      />
                                    </div>
                                    <div className="col-md-3">
                                      <span className="d-block pop_up">
                                        {
                                          actionState?.actionAttribute5
                                            ?.attribute
                                        }
                                        <PersonIcon />
                                      </span>
                                    </div>
                                    <div className="col-md-3 mt-auto">
                                      <button
                                        type="button"
                                        className="btn bg-gradient-primary w_btn m-0 bgdanger1 "
                                        onClick={removeConditionAction4}
                                      >
                                        <DeleteIcon />
                                      </button>
                                    </div>
                                  </>
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>

                            {/*.........................End Of Action Condition 3................................. */}

                            <div class="mt-4 text-sm text-end">
                              <button
                                type="submit"
                                // onClick={SpamPost}
                                className="btn bg-gradient-primary mt-4 me-4 w_btn"
                              >
                                Save
                                <i class="material-icons opacity-10">
                                  arrow_right_alt
                                </i>
                              </button>
                              <button
                                // onClick={formik.resetForm}
                                onClick={(e) => {
                                  ResetState();
                                  formik.resetForm(e);
                                }}
                                type="button"
                                className="btn bg-gradient-secondary mt-4 w_btn"
                              >
                                Reset
                                <SettingsBackupRestoreRoundedIcon
                                  style={{ fontSize: "17px" }}
                                />
                              </button>
                            </div>
                            {/* {andPopup1  undefined && ( */}
                    <div>
                      <button
                        ref={PopupModal1}
                        type="button"
                        className="btn btn-primary d-none"
                        data-bs-toggle="modal"
                        data-bs-target="#staticBackdrop1"
                      >
                        Launch static backdrop modal
                      </button>

                      <div
                        className="modal fade"
                        id="staticBackdrop1"
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                        tabindex="-1"
                        aria-labelledby="staticBackdrop1Label"
                        aria-hidden="true"
                      >
                        <div className="modal-dialog">
                          <div className="modal-content">
                            <div className="modal-header">
                              <h5
                                className="modal-title"
                                id="staticBackdrop1Label"
                              >
                                Are You Sure to Unschedule this?
                              </h5>
                            </div>

                            <div className="modal-body">
                              <div className="modal-footer justify-content-center">
                                <button
                                  type="button"
                                  className="btn btn-primary editcolor shadow okbtn"
                                  data-bs-dismiss="modal"
                                  // onClick={UnSchedulGet}
                                >
                                  Ok
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-secondary shadow"
                                  data-bs-dismiss="modal"
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                            {/* <div class="modal-footer"> */}

                            {/* </div> */}
                          </div>
                        </div>
                      </div>
                    </div>
                  {/* )} */}
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </ThemeProvider>
              </div>
            </div>
          </div>
        </div>
      </main>
      <div style={{ marginLeft: "260px" }}></div>
    </>
  );
};
export default withRouter(SpamRules);
